import React from 'react'
import IonIcon from '@reacticons/ionicons'
import Conversation from '../../Chats/conversation'
import ReplyTextEditor from '../../Chats/replytexteditor'
import PrivateNotesWithDraggable from './notesdraggable'

const TicketPreviewModal = ({
  previewticket,
  previewstatuschange,
  handlepreviewstatuschange,
  previewpriority,
  handlepreviewprioritychange,
  setcustomerpreview,
  setActiveChatlogTab,
  activechatlogTab,
  referenceId,
  setIsSpinning,
  isSpinning,
  Setopenaddprivatenotes,
  Setopenupdateprivatenotes,
  notes,
  setHoveredNote,
  setpassticketid,
  setpassticketnotes,
  setpassnoteid,
  fetchNotes,
  passticketid
}) => {
  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[90] p-5'>
      <div
        className='bg-white shadow-lg w-full max-w-[1100px] mx-auto my-[30px] rounded-[24px] border border-white overflow-hidden min-h-[40%] max-h-[95%] h-[600px] scrollbar-hide flex flex-col'
        style={{ boxShadow: '-1px 0px 0px 0px #DFE5F1 inset' }}
      >
        {/* Close + Refresh */}
        <div className='flex sticky bg-white w-full mb-5 mt-4 border-b px-4 py-3 top-0 justify-between items-center border-[#E5E9EB] z-10'>
          <h2 className='font-bold text-[23px]'>Ticket Information</h2>
          <div className='flex items-center space-x-2'>
            <IonIcon
              onClick={() => {
                setIsSpinning(true)
                window.dispatchEvent(
                  new CustomEvent('chatagent', { detail: { success: true } })
                )
                setTimeout(() => setIsSpinning(false), 1000)
              }}
              name='refresh'
              className={`w-[40px] sm:w-[50px] h-[40px] sm:h-[50px] flex justify-center items-center rounded-full text-black text-[14px] sm:text-[22px] cursor-pointer transition-transform duration-700 ${
                isSpinning ? 'animate-spin' : ''
              }`}
            />
            <button
              className='w-[30px] sm:w-[40px] h-[30px] sm:h-[40px] flex justify-center items-center rounded-full text-black text-[14px] sm:text-[18px] cursor-pointer'
              aria-label='Close'
              onClick={() => {
                setcustomerpreview(false)
                setActiveChatlogTab('Conversation')
              }}
            >
              <svg width='30' height='30' viewBox='0 0 30 30' fill='none'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M9.1 7.775c-.366-.366-.96-.366-1.326 0-.366.366-.366.96 0 1.326L13.674 15l-5.9 5.9c-.366.366-.366.96 0 1.326.366.366.96.366 1.326 0L15 16.326l5.9 5.9c.366.366.96.366 1.326 0 .366-.366.366-.96 0-1.326L16.326 15l5.9-5.9c.366-.366.366-.96 0-1.326-.366-.366-.96-.366-1.326 0L15 13.674 9.1 7.775Z'
                  fill='#000'
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Body */}
        <div className='flex gap-3 px-4 py-2 flex-1 overflow-hidden'>
          {/* Left Column */}
          <div className='w-1/4 flex flex-col items-start h-full'>
            <div className='bg-[#7C50DD] bg-opacity-[9%] w-full px-4 py-3 rounded-[10px] overflow-y-auto h-full scrollbar-hide'>
              <Info label='Ticket #' value={previewticket.ticket_number} />
              <Info
                label='Name'
                value={previewticket.ChatUsers[0]?.name}
              />
              <Info
                label='Email'
                value={previewticket.ChatUsers[0]?.email}
              />
              <Info label='Message' value={previewticket.content} />

              <div className='mb-4'>
                <label className='block text-[14px] font-semibold mb-1'>
                  Status:
                </label>
                <select
                  value={previewstatuschange}
                  onChange={handlepreviewstatuschange}
                  className='border rounded-md w-full px-2 py-3 focus:outline-none text-[14px] text-[#52565c]'
                >
                  <option value='open'>Open</option>
                  <option value='inprogress'>In Progress</option>
                  <option value='resolved'>Resolved</option>
                  <option value='closed'>Closed</option>
                </select>
              </div>

              <div className='mb-4 relative'>
                <label className='block text-[14px] font-semibold mb-1'>
                  Priority:
                </label>
                <div className='relative'>
                  <select
                    value={previewpriority}
                    onChange={handlepreviewprioritychange}
                    className='border rounded-md w-full px-2 py-3 focus:outline-none appearance-none text-[14px] text-[#52565c]'
                  >
                    <option value='Highest'>Highest</option>
                    <option value='High'>High</option>
                    <option value='Medium'>Medium</option>
                    <option value='Low'>Low</option>
                  </select>
                  <IonIcon
                    name='chevron-down'
                    className='absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none'
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Middle Column */}
          <div className='w-1/2 h-full border border-[#E5E9EB] rounded-[16px] flex flex-col overflow-hidden'>
            {/* Tabs */}
            <div className='flex sticky top-0 bg-white h-[45px] items-end border-b border-[#E5E9EB] z-10'>
              {['Conversation', 'Reference'].map(tab => (
                <button
                  key={tab}
                  onClick={() => setActiveChatlogTab(tab)}
                  className={`flex-1 text-sm font-medium py-2 text-center transition-all ${
                    activechatlogTab === tab
                      ? 'border-b-2 border-[#7C50DD] text-[#7C50DD]'
                      : 'text-gray-500'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className='flex-1 overflow-y-auto px-4 scrollbar-hide'>
              {activechatlogTab === 'Conversation' ? (
                <Conversation
                  chatlistId={localStorage.getItem('chatlist_customer_id')}
                />
              ) : (
                <Conversation chatlistId={referenceId} />
              )}
            </div>

            {activechatlogTab === 'Conversation' && (
              <div className='sticky bottom-0 w-full bg-white px-4 py-2'>
                <ReplyTextEditor ticket_id={previewticket.ticket_id} />
              </div>
            )}
          </div>

          {/* Right Column - Notes */}
          <div className='w-1/4 h-full border border-[#E5E9EB] rounded-[16px] flex flex-col overflow-hidden'>
            <div className='flex h-[45px] items-center justify-between px-4 border-b border-[#E5E9EB]'>
              <label className='text-[14px] font-semibold'>Notes</label>
              <button
                onClick={() => Setopenaddprivatenotes(true)}
                className='bg-[#F7F7F7] flex justify-center items-center gap-1 border-[1px] p-[5px] border-[#EBEBEB] rounded-[40px]'
              >
                <IonIcon name='add-outline' />
                <p className='text-[12px]'>Add Note</p>
              </button>
            </div>
            <div className='flex-1 overflow-y-auto py-4 px-4 scrollbar-hide'>
              <PrivateNotesWithDraggable
                notes={notes}
                clickupdatebtn={note => {
                  setHoveredNote(null)
                  Setopenupdateprivatenotes(true)
                  setpassticketid(note.ticket_id)
                  setpassticketnotes(note.ticket_notes)
                  setpassnoteid(note.id)
                }}
                clickdetelebtn={fetchNotes}
                ticketid={passticketid}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Info = ({ label, value }) => (
  <div className='mb-4'>
    <label className='block text-[14px] font-semibold mb-1'>{label}</label>
    <p className='text-[14px] text-[#52565c]'>{value || 'N/A'}</p>
  </div>
)

export default TicketPreviewModal
